import React from 'react';
import { Home_Contacts } from '../../../utils/config'

function Contact() {

  return (
    <div className='mt-[17.9vh] px-[12px]'>
        <div className=' border-b border-form-bg pb-[16px]'>
          {
            Home_Contacts.map((ad, ind) => {
              return (
                <div key={`${ad}${ind}`} className=' mt-[8px] text-black text-2lg font-sans text-center'>
                  {ad}
                </div>
              )
            })
          }
        </div>
    </div>
  );
}

export default Contact;
